module.exports = __webpack_public_path__ + "media/src/images/logos/clearbit-261e3d5c931286c57c288623f83f93df.png";